import { getUpdateSiteStatusUrl } from './urls.js';
export const getTaskStatus = async (httpClient, taskId) => {
    const { data } = await httpClient.get(getUpdateSiteStatusUrl(taskId));
    return data;
};
